import { styled, Typography } from "@mui/material"

const getBorder = (isDragAccept, isDragReject, theme) => {
    if (isDragAccept) {
        return `1px dashed ${theme.palette["primary"].main}`
    }
    if (isDragReject) {
        return `1px solid ${theme.palette["error"].main}`
    }
    return `1px dashed ${theme.palette.divider}`
}

const getBackgroundColor = (isDragAccept, isDragReject, theme, defaultColor = "#fff") => {
    if (isDragAccept) {
        return theme.palette["primary/_states/hover"].main
    }
    if (isDragReject) {
        return theme.palette["error/_states/hover"].main
    }
    return defaultColor
}

export const Container = styled("div", {
    shouldForwardProp: (prop) => prop !== "isFocused" && prop !== "isDragAccept" && prop !== "isDragReject" && prop !== "hidden",
})(({ theme, isDragAccept, isDragReject, hidden }) => ({
    border: getBorder(isDragAccept, isDragReject, theme),
    borderRadius: 12,
    padding: theme.spacing(6, 4),
    display: hidden ? "none" : "flex",
    gap: theme.spacing(2),
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: getBackgroundColor(isDragAccept, isDragReject, theme),
    transition: "background-color 0.3s ease, color 0.3s ease",

    "&:hover": {
        backgroundColor: getBackgroundColor(isDragAccept, isDragReject, theme, theme.palette["primary/_states/hover"].main),
        border: `1px dashed ${theme.palette["primary"].main}`,
    },
}))

export const FakeLink = styled("span", { shouldForwardProp: (prop) => prop !== "disabled" })(({ theme, disabled }) => ({
    color: disabled ? "inherit" : theme.palette["primary"].main,
    cursor: "pointer",
    textDecoration: "underline",
    textAlign: "center",
}))

export const AcceptedFilesText = styled(Typography)(({ theme }) => ({
    color: theme.palette["text/secondary"].main,
    textAlign: "center",
}))

export const RejectedFilesText = styled(Typography)(({ theme }) => ({
    color: theme.palette["error"].main,
    textAlign: "center",
}))